<template>
  <div>
    <h6 class="booking-details-title">{{ item.label }}</h6>
    <table class="table table-hover table-sm table-striped border">
      <tbody>
        <tr>
          <td>
            <b><translate>Hotel</translate>: </b>
          </td>
          <td>{{ item.hotel_info.hotel }}</td>
        </tr>
        <tr>
          <td>
            <b><translate>Room category</translate>: </b>
          </td>
          <td>{{ item.hotel_info.room_category }} </td>
        </tr>
        <tr>
          <td>
            <b><translate>Check in</translate>: </b>
          </td>
          <td>{{ checkIn }}</td>
        </tr>
        <tr>
          <td>
            <b><translate>Duration</translate>: </b>
          </td>
          <td>{{ item.duration }} nopti </td>
        </tr>
        <tr>
          <td>
            <b><translate>Check out</translate>:</b>
          </td>
          <td>{{ checkOut }}</td>
        </tr>
        <tr>
          <td>
            <b><translate>Meals</translate>:</b>
          </td>
          <td> {{ item.hotel_info.meal_basis }}</td>
        </tr>
        <tr>
          <td>
            <b><translate>Room</translate>:</b>
          </td>
          <td>
            {{ rooms }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'HotelItemInfo',
  props: ['item'],
  computed: {
    checkIn () {
      return moment(this.item.start_date).format('DD-MM-YYYY')
    },
    checkOut () {
      return moment(this.item.end_date).format('DD-MM-YYYY')
    },
    rooms () {
      const rooms = this.item.hotel_info.rooms.reduce((acc, el) => {
        const elIndex = acc.findIndex(exEl => exEl.name === el.name)
        if (elIndex >= 0) acc[elIndex].count++
        else acc.push({ name: el.name, count: 1 })
        return acc
      }, [])
      return rooms.reduce((acc, el) => acc + (acc ? ', ' : '') + (el.count + ' x ' + el.name), '')
    }
  }
}
</script>
